// 图片上传
const uploadImage = async(params) => {
    const formData = new FormData();
    formData.append('pic', params.file);
    formData.append('path', params.path);
    const response = await fetch('https://api.fuyuncc.com/v1/data/save-pic', {
        method: 'POST',
        body: formData
    });
    const data = await response.json();
    return data.data;
};

export { uploadImage };

